import {BaseRequestOptions} from '@angular/http';

export class MyRequestOptions extends BaseRequestOptions {

    constructor() {
        super();
        this.append('X-Requested-With', 'XMLHttpRequest');
        this.append('X-XSRF-TOKEN', this.getCookie('XSRF-TOKEN'));
    }
    
    getCookie(name:string) {
        let value = "; " + document.cookie;
        let parts = value.split("; " + name + "=");
        if (parts.length == 2) 
          return parts.pop().split(";").shift();
    }
    
    append(name:string,value:string){
        this.headers.append(name, value);
    }
        
}


/** WEBPACK FOOTER **
 ** ./src/app/my.request.options.ts
 **/